<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({
  party: { type: Object, required: true },
  summary: { type: Boolean, default: false },
});
const { t } = useI18n();
const attorney = computed(() => props.party.profile?.attorney || {});
const hasAttorney = computed(() => Boolean(attorney.value.enabled));
const items = computed(() => [
  {
    key: 'attorney-name',
    label: props.summary
      ? t('SALES_PARTIES.SUMMARY.ATTORNEY_NAME')
      : t('SALES_PARTIES.ATTORNEY.NAME'),
    value: attorney.value.name,
  },
  {
    key: 'attorney-phone',
    label: props.summary
      ? t('SALES_PARTIES.SUMMARY.ATTORNEY_PHONE')
      : t('SALES_PARTIES.ATTORNEY.PHONE'),
    value: attorney.value.phone,
  },
]);
</script>

<template>
  <div>
    <LaisCard
      :title="t('SALES_PARTIES.ATTORNEY.SUMMARY_TITLE')"
      prefix-icon="i-lucide-file-signature"
    >
      <SalesDetailFactList v-if="hasAttorney" :items="items" />
      <p v-else class="text-sm text-lais-text-muted">
        {{ t('SALES_PARTIES.ATTORNEY.EMPTY') }}
      </p>
    </LaisCard>
  </div>
</template>
